import { CareerPathSelector } from './CareerPathSelector';
import { useSelectorSubmit } from './useSelectorSubmit';

export const CareerPathSelectorPanel = () => {
  const { required, submit } = useSelectorSubmit('careerPathSelector');

  return (
    <CareerPathSelector onSubmit={submit} onSkip={!required ? () => submit('None') : undefined} />
  );
};
